// @ts-nocheck
import React from 'react';

export const useHashParams = () => {
  // Always call hooks - check window inside hooks, not before
  const [hash, setHash] = React.useState(() =>
    typeof window !== 'undefined' ? window.location.hash : '',
  );

  const hashChangerHnadler = React.useCallback(() => {
    if (typeof window !== 'undefined') {
      setHash(window.location.hash);
    }
  }, []);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', hashChangerHnadler);
      return () => {
        window.removeEventListener('hashchange', hashChangerHnadler);
      };
    }
  }, [hashChangerHnadler]);

  const updateHash = React.useCallback(
    (newHash: string) => {
      if (typeof window !== 'undefined' && newHash !== hash) {
        window.location.hash = newHash;
      }
    },
    [hash],
  );

  return [hash, updateHash] as const;
};
